import styled from 'styled-components/macro';

export const ScTableBody = styled.div`
	display: table-row-group;
`;
